import { Typography, Button, Input, Form, Layout, Card, Flex } from "antd";
const { Title } = Typography;
const ResetPassword = () => {
  return (
    <>
      <Layout>
        <Flex
          gap="middle"
          align="center"
          justify="center"
          vertical
          style={{ minHeight: "100vh" }}
        >
          <Card className="relative">
            <img
              width={100}
              src="LogoSquare.svg"
              alt=""
              className="mx-auto absolute top-[-120px] left-0 right-0"
            />
            <Title level={3} align={"center"}>
              Reset Password
            </Title>
            <Form
              name="login"
              layout="vertical"
              style={{
                maxWidth: 400,
                minWidth: 400,
                marginTop: 24,
              }}
              initialValues={{
                remember: true,
              }}
              // onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="New Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your new password!",
                  },
                ]}
              >
                <Input.Password size="large" />
              </Form.Item>
              <Form.Item
                label="Confirm Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your confirm password!",
                  },
                ]}
              >
                <Input.Password size="large" />
              </Form.Item>
              <Button
                className="w-full mt-4"
                size="large"
                type="primary"
                htmlType="submit"
              >
                Change password
              </Button>
            </Form>
          </Card>
        </Flex>
      </Layout>
    </>
  );
};
export default ResetPassword;